export const RATE_TYPES = {
  COMPOSITE: "Composite",
  FLAT: "Flat",
  AGE_BANDED: "Age Banded",
  BASIC_LIFE: "Basic Life",
  VOLUNTARY_LIFE: "Voluntary Life",
  AGE_BANDED_GENDER: "Age Banded Gender",
  AGE_BANDED_TOBACCO: "Age Banded Tobacco",
  CRITICAL_ILLNESS: "Critical Illness",
  AGE_BANDED_TIERED: "Age Banded Tiered",
} as const;
